import URL from '../helper';
import axiosCall from './interceptor';

export const waitForApproval = async (page, type, name, tags, categoryIds) => {
  let payload = {
    page,
  };
  if (name) {
    payload.name = name;
  }
  if (tags) {
    payload.tags = tags;
  }
  if (categoryIds) {
    payload.categoryIds = categoryIds;
  }

  const searchParams = new URLSearchParams(payload);
  const url = `${
    URL.TRANSACTION_SYSTEM_URL
  }qaReadyDocument?qaReadyStatus=qacomplete&limit=8&rgPermission=write&${searchParams.toString()}`;
  let response = await axiosCall('get', url);
  return response.data;
};
